<template>
  <div>
    <div class="hero taptrader-bg">
      <div class="inner">
        <h1>TAP Trader</h1>
        <h5 class="subtitle">Trading platform for global derivatives</h5>
        <div class="hero-btn-container" @click="goContact">
          <BtnPrimary text="Request a Demo" />
        </div>
      </div>
    </div>
    
    <section class="section3">
      <div class="section-inner">
				<h2 class="section-title">{{$t('tapPage.text1')}}</h2>
        <p class="center" v-html="$t('tapPage.text2')"></p>
				<div class="spacer"></div>
        <div class="col4-grid center">
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/tap-icon1.svg" alt="" /></div>
            <h5>{{$t('tapPage.text3')}}</h5>
            <p>{{$t('tapPage.text4')}}</p>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/tap-icon2.svg" alt="" /></div>
            <h5>{{$t('tapPage.text5')}}</h5>
            <p>{{$t('tapPage.text6')}}</p>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/tap-icon3.svg" alt="" /></div>
            <h5>{{$t('tapPage.text7')}}</h5>
            <p>{{$t('tapPage.text8')}}</p>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/tap-icon4.svg" alt="" /></div>
            <h5>{{$t('tapPage.text9')}}</h5>
            <p>{{$t('tapPage.text10')}}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="orange">
      <div class="section-inner">
				<h2 class="section-title">{{$t('tapPage.text11')}}</h2>
				<div class="spacer"></div>
        <div class="col3-grid center">
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/tap-icon5.svg" alt=""></div>
            <h5>{{$t('tapPage.text12')}}</h5>
          </div>
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/tap-icon6.svg" alt=""></div>
            <h5>{{$t('tapPage.text13')}}</h5>
          </div>
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/tap-icon7.svg" alt=""></div>
            <h5>{{$t('tapPage.text14')}}</h5>
          </div>
        </div>
      </div>
    </section>
		<section class="section3">
      <div class="section-inner">
        <h2 class="section-title">{{$t('tapPage.text15')}}</h2>
        <p v-html="$t('tapPage.text16')"></p>
      </div>
    </section>
		<section class="section3 light-gray">
      <div class="section-inner">
        <h2 class="section-title">{{$t('tapPage.text17')}}</h2>
        <p>{{$t('tapPage.text18')}}</p>
        <router-link to="contact" class="contact-us"><BtnPrimary text="Contact us" /></router-link>
      </div>
    </section>
  </div>
</template>

<script>
import BtnPrimary from '@/components/BtnPrimary.vue';

export default {
  name: 'TapPage',
  components: { BtnPrimary },
  data() {
    return {};
  },

  mounted() {},

  methods: {
    goContact() {
      this.$router.push('contact')
    }    
  },
};
</script>

<style lang="scss" scoped></style>
